<ion-app [ngClass]="brandClass">
  <router-outlet></router-outlet>
</ion-app>
